module.exports = __webpack_public_path__ + "img/hire_property1.e07efd51.jpg";